import React, { useState, useEffect } from 'react';
import Loader from "../../Shared/Loader/Loader";
import { Button } from "primereact/button";
import "primereact/resources/themes/lara-light-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import Toast from '../../Shared/Toast/Toast';
import APIConstant from "../../../utils/pathConstants";
import CommonConfig from "../../../utils/constant";
import api from "../../../utils/apiClient";
import { Checkbox } from 'primereact/checkbox';
import { Dropdown } from 'primereact/dropdown';
import { useCatchResponse } from '../../../utils/useCatchResponse';
import { Card } from 'primereact/card';
import { Slider } from 'primereact/slider';
import { Divider } from 'primereact/divider';

const GeneralConfiguration = () => {
  const { catchResponse } = useCatchResponse();
  const [isClassTeacher, setIsClassTeacher] = useState(true);
  const [isSubjectTeacher, setIsSubjectTeacher] = useState(false);
  const [isAcademicYearApply, setIsAcademicYearApply] = useState(false);
  const [securityUserID, setSecurityUserID] = useState("");
  const [configurationId, setConfigurationId] = useState("");
  const [studentQuality, setStudentQuality] = useState(0.2);
  const [teacherQuality, setTeacherQuality] = useState(0.2);
  const [parentQuality, setParentQuality] = useState(0.2);
  const [isGpsAttendanceEnabled, setIsGpsAttendanceEnabled] = useState(false);
  const [nameFormat, setNameFormat] = useState('FirstSurname');


  useEffect(() => {
    const loginData = CommonConfig.loginData();
    setSecurityUserID(loginData?._id);
    GetConfigurationData(loginData?._id);
  }, []);

  const toQuality = (v, fallback = 0.2) => {
    const n = typeof v === 'string' ? parseFloat(v.replace(',', '.')) : Number(v);
    if (!Number.isFinite(n)) return fallback;
    return Math.min(1, Math.max(0.1, n));
  };

  const GetConfigurationData = async (id) => {
    try {
      let data = {
        id: id,
      }
      await api.post(APIConstant.path.GetGeneralConfigurationDetail, data).then(async response => {
        let res = response;
        if (res.success) {
          setConfigurationId(res?.data?._id);
          setIsSubjectTeacher(res?.data?.IsSubjectTeacher);
          setIsAcademicYearApply(res?.data?.IsAcademicYearApply);
          setIsClassTeacher(res?.data?.IsClassTeacher);
          setIsGpsAttendanceEnabled(!!res?.data?.IsGpsAttendanceEnabled);
          setNameFormat(res?.data?.NameFormat || 'FirstSurname');
          setStudentQuality(toQuality(res?.data?.StudentConfig, 0.2));
          setParentQuality(toQuality(res?.data?.ParentConfig, 0.2));
          setTeacherQuality(toQuality(res?.data?.TeacherConfig, 0.2));
          Loader.hide();
        }
      }).catch(err => {
        Loader.hide();
        console.log(err);
        catchResponse(err);
      });
    } catch (err) {
      console.log(err);
      catchResponse(err);
    }
  }

  const handleSubmit = async (e) => {
    try {
      Loader.show();
      let data = {
        id: configurationId,
        IsClassTeacher: isClassTeacher,
        IsSubjectTeacher: isSubjectTeacher,
        IsAcademicYearApply: isAcademicYearApply,
        IsGpsAttendanceEnabled: isGpsAttendanceEnabled,
        NameFormat: nameFormat,
        StudentConfig: studentQuality,
        ParentConfig: parentQuality,
        TeacherConfig: teacherQuality,
        CreatedBy: securityUserID,
      };
      await api
        .post(APIConstant.path.AddUpdateGeneralConfiguration, data)
        .then((response) => {
          let res = response;
          if (res.success) {
            Toast.success({ message: res.message });
            Loader.hide();
            GetConfigurationData(securityUserID);
          } else {
            Toast.error({ message: res.message });
            Loader.hide();
          }
        })
        .catch((err) => {
          console.log(err);
          Loader.hide();
        });
    } catch (err) {
      console.log(err);
      Loader.hide();
      catchResponse(err);
    }
  };

  const buildQualitySlider = (title, value, setValue) => (
    <Card className="quality-card-light p-4 mb-3 border-round-xl">
      <div className="flex flex-column gap-3">
        {/* Header */}
        <div className="p-d-flex p-ai-center p-jc-between">
          <div className="flex align-items-center gap-2">
            <p className="card-title-light p-m-0">{title}</p>
          </div>

          <p className={`status-chip-light p-m-0 ${value < 4 ? 'danger' : value < 7 ? 'warning' : 'success'
            }`}>
            {value < 4 ? 'Low' : value < 7 ? 'Medium' : 'High'}
          </p>
        </div>

        {/* Slider */}
        <div className={`slider-light p-my-2 ${value < 4 ? 'low' : value < 7 ? 'mid' : 'high'
          }`}>
          <Slider
            value={value * 10}
            onChange={(e) => setValue(e.value / 10)}
            step={1}
            min={1}
            max={10}
          />
        </div>

        {/* Footer */}
        <div className="p-d-flex p-ai-center p-jc-between">
          <p className="quality-label-light p-m-0">Quality Score</p>
          <div className={`quality-pill-light ${value < 4 ? 'danger' : value < 7 ? 'warning' : 'success'
            }`}>
            {value?.toFixed(1)}
          </div>
        </div>

      </div>
    </Card>


  );


  return (
    <div className='wayment-owner-dashboard et-master-page'>
      <div className="heading-area p-d-flex p-ai-center p-jc-between">
        <div className="p-d-flex p-ai-baseline">
          <i className="pi pi-wrench"></i>
          <h2>General Configuration</h2>
        </div>
      </div>
      <div className="flex align-items-center gap-2 mb-3">
        <h3 className="m-0 text-lg font-semibold text-700">Marks to be given</h3>
      </div>
      <div className='p-d-flex flex-column p-jc-between e-class-time-table' style={{ maxHeight: 'calc(100vh - 180px)', overflowY: 'auto' }}>
        <div className="p-grid p-px-2">
          <div className="p-col-12 p-md-4">
            <div className="">
              <Checkbox
                inputId="classTeacher"
                name="isClassTeacher"
                value="IsClassTeacher"
                onChange={(e) => {
                  setIsClassTeacher(e.checked);
                }}
                checked={isClassTeacher}
              />
              <label htmlFor="classTeacher" className="p-ml-2"> Class Teacher</label>
            </div>
          </div>
          <div className="p-col-12 p-md-4">
            <div className="">
              <Checkbox
                inputId="subjectTeacher"
                name="isSubjectTeacher"
                value="IsSubjectTeacher"
                onChange={(e) => {
                  setIsSubjectTeacher(e.checked);
                }}
                checked={isSubjectTeacher}
              />
              <label htmlFor="subjectTeacher" className="p-ml-2"> Subject Teacher</label>
            </div>
          </div>
          <div className="p-col-12 p-md-4">
            <div className="">
              <Checkbox
                inputId="academicYearApply"
                onChange={(e) => {
                  setIsAcademicYearApply(e.checked);
                }}
                checked={isAcademicYearApply}
              />
              <label htmlFor="academicYearApply" className="p-ml-2">Academic year Apply</label>
            </div>
          </div>
          <div className="p-col-12 p-md-4">
            <div className="">
              <Checkbox
                inputId="gpsAttendance"
                onChange={(e) => {
                  setIsGpsAttendanceEnabled(e.checked);
                }}
                checked={isGpsAttendanceEnabled}
              />
              <label htmlFor="gpsAttendance" className="p-ml-2">Enable GPS-based Staff Attendance</label>
            </div>
          </div>
          <div className="p-col-12 p-md-4">
            <div className="custom-inputs">
              <label className='p-d-block' htmlFor="nameFormat">Full Name Format</label>
              <Dropdown
                id="nameFormat"
                className='p-w-100 p-mt-1'
                value={nameFormat}
                options={CommonConfig.nameTypeList}
                onChange={(e) => setNameFormat(e.value)}
                placeholder="Select Name Format"
              />
            </div>
          </div>
          <div className='p-d-flex p-ai-center p-jc-between p-w-100 p-mt-2'>
            {buildQualitySlider("Student Image Quality", studentQuality, setStudentQuality)}
            {buildQualitySlider("Parent Image Quality", parentQuality, setParentQuality)}
            {buildQualitySlider("Teacher Image Quality", teacherQuality, setTeacherQuality)}
          </div>
        </div>
      </div>
      <div className="p-d-flex p-ai-center p-jc-end">
        <Button label="Save" onClick={handleSubmit} className="btn-text-action-primary p-m-0" />
      </div>
    </div>

  );
};

export default GeneralConfiguration;
